import axios from "axios";
import moment from "moment";
import groupBy from "lodash/groupBy";
import reverse from "lodash/reverse";
import map from "lodash/map";
// import mock from "@/mock/timeline.json";

const group = json => {
  const grouped = groupBy(json, item => {
    return moment(item.date).format("YYYY");
  });
  const mapped = map(grouped, (d, i) => {
    return {
      year: i,
      timeline: d
    };
  });
  return reverse(mapped);
};

const getUpcomingEvents = json => {
  const upcoming = json.filter(data =>
    moment(data.date).isAfter(moment().format(), "second")
  );
  if (upcoming.length === 0) {
    return [];
  } else {
    return reverse(upcoming);
  }
};

// state
const state = () => ({
  timeline: [],
  upcomingEvents: [],
  loading: false,
  error: false
});

// mutations
const mutations = {
  SET_DATA(state, data) {
    state.timeline = group(data);
    state.upcomingEvents = getUpcomingEvents(data);
  },
  SET_LOADING(state, data) {
    state.loading = data;
  },
  SET_ERROR(state, data) {
    state.error = data;
  }
};

// actions
const actions = {
  async get({ commit }) {
    console.log("Getting timeline");
    try {
      commit("SET_LOADING", true);

      const { data } = await axios.get("/.netlify/functions/timeline");
      // const data = mock;
      commit("SET_LOADING", false);
      commit("SET_ERROR", false);
      commit("SET_DATA", data);
    } catch (error) {
      commit("SET_DATA", []);
      commit("SET_LOADING", false);
      commit("SET_ERROR", true);
    }
  },
  async getHealth() {
    try {
      const { data } = await axios.get("/.netlify/functions/health");
      console.log(data);
    } catch (error) {}
  }
};

export default { namespaced: true, state, mutations, actions };
